import React from "react";
import { getColumnsData } from "./DeploymentColumns";
import { getDeploymentData } from "../../services/deployment";
import OTAPagination from "../OTAPagination";

const DeploymentListTable = (props) => {
  const columns = getColumnsData();

  return (
    <OTAPagination
      columns={columns}
      endpointFn={getDeploymentData}
      queryName={"deployments"}
      filterMode="server"
      sortByDefault={"campaignCreationDate"}
      getRowId={(row) => row.deploymentId}
      exportCSV
      tableTitle={"Created Deployments"}
      {...props}
    />
  );
};

DeploymentListTable.defaultProps = {};

DeploymentListTable.propTypes = {};

export default DeploymentListTable;
